import { IFullPlanDetail, IFullPlanDetailPPO } from "../../../interfaces/api";
import { getSingleDeepHMO } from "../../../functions/planDetails";
import SingleInfoBenefitTripled from "./SingleInfoBenefitTripled.component";

import comArray from "../../../shared/CompareData";
import comFullArrayEquality from "../../../shared/EqualityArray.component";

interface IProps {
  compData: IFullPlanDetail[] | IFullPlanDetailPPO[];
  highlightDifferences: boolean;
  uniqueName: string;
}

const ComparisonTableOverview = (props: IProps) => {
  const plansNumber = props.compData.length;
  const equality = comFullArrayEquality(props.compData);

  const visionEqualityData = equality.find(
    (item) => item.name === props.uniqueName
  );
  const isMonthlyPremiumEqual = visionEqualityData?.childrens.find(
    (item) => item.name === "Monthly Premium"
  )?.equal;
  const isDeductibleEqual = visionEqualityData?.childrens.find(
    (item) => item.name === "Deductible"
  )?.equal;
  const isMaxOutOfPocketEqual = visionEqualityData?.childrens.find(
    (item) => item.name === "Maximum Out-of-Pocket"
  )?.equal;
  const isPartBEqual = visionEqualityData?.childrens.find(
    (item) => item.name === "Part B Rebate"
  )?.equal;

  return (
    <div
      className="grid-x"
      style={{
        backgroundColor: "white",
        border: "1px solid #D3E1F0",
      }}
    >
      {comArray.map((segment, index) =>
        segment.name === props.uniqueName
          ? segment.childrens.map((part, index) => (
              <div
                key={index}
                className="grid-x small-12"
                style={{ fontSize: "18px" }}
              >
                <div
                  className={
                    plansNumber === 3 ? "cell small-3" : "cell small-4"
                  }
                  style={{
                    height: "100%",
                    padding: "32px 20px",
                    borderBottom: "1px solid #D3E1F0",
                    textAlign: "start",
                    fontWeight: 600,
                  }}
                >
                  {part.name}
                </div>
                {props.compData.map((plan, index) => (
                  <div
                    className={
                      plansNumber === 3 ? "cell small-3" : "cell small-4"
                    }
                    key={index}
                  >
                    {part.name === "Monthly Premium" && (
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          padding: "32px 20px",
                          borderBottom: "1px solid #D3E1F0",
                          textAlign: "start",
                          backgroundColor:
                            props.highlightDifferences && !isMonthlyPremiumEqual
                              ? "#F4F0ED"
                              : "transparent",
                        }}
                      >
                        {plan.PlanDetails[0].MonthlyPremiumAmount >= 0
                          ? plan.PlanDetails[0].MonthlyPremiumAmount % 1 !== 0
                            ? "$" +
                              plan.PlanDetails[0].MonthlyPremiumAmount.toFixed(
                                2
                              )
                            : "$" + plan.PlanDetails[0].MonthlyPremiumAmount
                          : "-"}
                      </div>
                    )}
                    {part.name === "Deductible" && (
                      <SingleInfoBenefitTripled
                        differences={props.highlightDifferences}
                        equal={isDeductibleEqual}
                        benefit={getSingleDeepHMO(
                          plan as IFullPlanDetail,
                          "Deductible"
                        )}
                      />
                    )}
                    {part.name === "Maximum Out-of-Pocket" && (
                      <SingleInfoBenefitTripled
                        differences={props.highlightDifferences}
                        equal={isMaxOutOfPocketEqual}
                        benefit={getSingleDeepHMO(
                          plan as IFullPlanDetail,
                          "Maximum Out-of-Pocket Responsibility"
                        )}
                      />
                    )}
                    {part.name === "Part B Rebate" && (
                      <SingleInfoBenefitTripled
                        differences={props.highlightDifferences}
                        equal={isPartBEqual}
                        benefit={getSingleDeepHMO(
                          plan as IFullPlanDetail,
                          "Part B Reduction"
                        )}
                        hmoBReduction={
                          plan.PlanDetails[0].company[0].healthPlan[0].lob ===
                          "HMO"
                            ? true
                            : false
                        }
                      />
                    )}
                  </div>
                ))}
              </div>
            ))
          : null
      )}
    </div>
  );
};

export default ComparisonTableOverview;
